import React, { useState, useEffect } from 'react';
import Modal from '../../atoms/modal/view';
import ComprobanteForm from '../../molecules/ComprobanteForm/view.jsx';
import { updateComprobante, getComprobante } from '../../../usecases/accounting-usecase';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { dateFormat } from '../../../utils/helper';

const EditComprobanteModal = () => {
    const [editData, setEditData] = useState(null);
    const [originalId, setOriginalId] = useState(null);
    const id = "editComprobanteModal";

    useEffect(() => {
        const handleEditData = async (event) => {
            let original = event.detail.data;
            if (!original) return;

            setOriginalId(original.id);

            // Si el objeto no tiene líneas, intentamos obtenerlas del backend
            if ((!original.lineas || original.lineas.length === 0) && (!original.lines || original.lines.length === 0)) {
                try {
                    const fullData = await getComprobante(original.id);
                    if (fullData) {
                        original = fullData;
                    }
                } catch (error) {
                    console.error("Error fetching full comprobante for edit:", error);
                }
            }

            const linesSource = original.lineas || original.lines || [];
            const mappedLines = linesSource.map((line, idx) => {
                const uAcc = line.users_accounts || line.user_account;
                const accountDescription = uAcc?.description || line.descripcion || undefined;

                let accountCode = "N/A";
                if (uAcc && uAcc.account) {
                    const baseCode = uAcc.account.account || "";
                    const code = uAcc.code !== undefined ? uAcc.code : "";
                    accountCode = code > 9 ? `${baseCode}${code}` : `${baseCode}0${code}`;
                } else if (uAcc?.code) {
                    accountCode = uAcc.code;
                }

                return {
                    numero_linea: line.numero_linea || (idx + 1),
                    cuenta_contable_id: line.cuenta_contable_id || uAcc?.id,
                    tercero_id: line.tercero_id || line.third_id,
                    tercero_object: line.tercero_object || line.tercero || line.third,
                    centro_costo_id: line.centro_costo_id || 1,
                    valor_debito: Number(line.valor_debito || 0),
                    valor_credito: Number(line.valor_credito || 0),
                    descripcion: line.descripcion || '',
                    aditional_info: {
                        ...uAcc,
                        account: accountCode,
                        description: accountDescription,
                        need_third: uAcc?.need_third || line.need_third || false
                    }
                };
            });

            // Extraer el tipo de documento (código corto)
            const rawDocType = original.document_type || original.tipo || original.type || '';
            let finalDocType = rawDocType;
            if (rawDocType.includes('(') && rawDocType.includes(')')) {
                const match = rawDocType.match(/\(([^)]+)\)/);
                if (match) finalDocType = match[1];
            }
            if (finalDocType === 'N/A') finalDocType = '';

            setEditData({
                descripcion: original.descripcion || original.concept || '',
                document_type: finalDocType,
                document: original.document || '',
                date: original.date ? original.date.split('T')[0] : dateFormat(new Date()),
                lineas: mappedLines
            });

            // Si el comprobante original tiene un ID, cerramos su modal de detalle si está abierto
            if (original.id) {
                dispatchCustomEvent(`close-comprobante${original.id}-modal`, []);
            }

            // Abrir el modal
            dispatchCustomEvent(`modal${id}`, { eventKey: id });
        };

        window.addEventListener('edit-comprobante-data', handleEditData);
        return () => window.removeEventListener('edit-comprobante-data', handleEditData);
    }, []);

    const handleSave = async (formData) => {
        try {
            await updateComprobante(originalId, formData);
            dispatchCustomEvent(`close-${id}-modal`, []); 
            dispatchCustomEvent("popup", { message: "Comprobante actualizado correctamente", type: "success" });
            dispatchCustomEvent("reload-comprobantes", {}); 
        } catch (error) {
            console.error("Error updating comprobante:", error);
            dispatchCustomEvent("popup", { message: "Error al actualizar el comprobante. Verifique los datos.", type: "error" });
            dispatchCustomEvent('loading-btn-comprobante-save', {});
        }
    };

    return (
        <Modal id={id} title="Editar Comprobante Contable" size="xl">
            {editData && (
                <ComprobanteForm 
                    initialData={editData} 
                    onSave={handleSave} 
                    submitTitle="Actualizar Comprobante"
                />
            )}
        </Modal>
    );
};

export default EditComprobanteModal;
